const { REACT_APP_API_URL, REACT_APP_COOKIES_KEY, REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;

export const API_URL = REACT_APP_API_URL || '';
export const COOKIES_KEY = REACT_APP_COOKIES_KEY || '';
export const SUPABASE_URL = REACT_APP_SUPABASE_URL || '';
export const SUPABASE_KEY = REACT_APP_SUPABASE_KEY || '';